import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { EndpointsIntegrations } from '../integrations-flow/EndpointsIntegrations';
import { EndpointsStandaloneCmsPartner } from './EndpointsStandaloneCmsPartner';
import { EndpointsChatSpot } from './http-chatspot/EndpointsChatSpot';
export const getFlowEndpointOverrides = () => {
  switch (getFlowKey()) {
    case Flow.Integrations:
      return EndpointsIntegrations;

    case Flow.StandaloneCmsPartner:
      return EndpointsStandaloneCmsPartner;

    case Flow.ChatSpot:
      return EndpointsChatSpot;

    default:
      return {};
  }
};